<template>
  <div class="arcgis-map">
    <div id="map" class="arcgis-map"></div>
    <div id="overview-map" v-show="overviewVisible"></div>
    <div id="tool-bar">
      <el-dropdown :hide-on-click="false" trigger="click">
        <span class="el-dropdown-link">
          <i class="el-icon-s-operation"></i>
          选择
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-radio-group v-model="selectionType" @change="handleBoxRadio">
            <el-dropdown-item>
              <el-radio label="1">点选</el-radio>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-radio label="2">框选</el-radio>
            </el-dropdown-item>
          </el-radio-group>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown :hide-on-click="false" trigger="click">
        <span class="el-dropdown-link">
          <i class="el-icon-s-flag"></i>
          标注
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-radio-group v-model="classificationMethod" @change="handleRadio">
            <el-dropdown-item>
              <el-radio label="1">不标注</el-radio>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-radio label="2">按地域标注</el-radio>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-radio label="3">按行业标注</el-radio>
            </el-dropdown-item>
          </el-radio-group>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown @command="handleCommand" placement="bottom" trigger="click">
        <span class="el-dropdown-link">
          <i class="el-icon-s-cooperation"></i>
          工具箱
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="overviewMap"><i class="el-icon-check" v-show="overviewVisible"></i>鹰眼</el-dropdown-item>
          <el-dropdown-item command="scaleBar"><i class="el-icon-check" v-show="scaleBarVisible"></i>比例尺</el-dropdown-item>
          <el-dropdown-item command="distanceMeasure"><i class="el-icon-check" v-show="distanceMeasurementVisible"></i>测距</el-dropdown-item>
          <el-dropdown-item command="coordinateConversion"><i class="el-icon-check" v-show="coordinateConversionVisible"></i>取点</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import ArcgisMap from './ArcgisMap.js'
export default ArcgisMap
</script>

<style lang="scss">
@import "ArcgisMap.scss";
</style>



// WEBPACK FOOTER //
// src/components/arcgisMap/ArcgisMap.vue